import { RowRendererProps } from 'react-arborist'
import { ProjectItem } from '../ProjectItem'

// Adds aria-label
// https://github.com/brimdata/react-arborist/blob/main/modules/react-arborist/src/components/default-row.tsx
export function ProjectNavigatorRow({ node, attrs, innerRef, children }: RowRendererProps<ProjectItem>) {
  return (
    <div
      aria-label={node.data.name}
      {...attrs}
      ref={innerRef}
      onFocus={(e) => e.stopPropagation()}
      onClick={node.handleClick}
    >
      {children}
    </div>
  )
}
